import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from '../components/LoadingSpinner';

interface GlobalAdminGuardProps {
  children: React.ReactNode;
}

export function GlobalAdminGuard({ children }: GlobalAdminGuardProps) {
  const { isGlobalAdmin, isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while auth state is being initialized from localStorage
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isGlobalAdmin) {
    return <Navigate to="/admin/access-denied" replace />;
  }

  return <>{children}</>;
}
